export default {
    methods: {
        async onFileChange(e, entity, key) {
            console.log("File changed e, entity, key", e, entity, key);
            key = key ? key + "File" : "file";

            let file;
            if (e.files) {
                file = e.files[0];
            }
            if (!file) {
                file = e.target.files[0];
            }
            entity[key] = file;
            entity[key + "Name"] = this.$uuid.v4() + file.name.substring(file.name.lastIndexOf("."));
            console.log("End File changed", entity[key], entity[key + "Name"]);
        },

        // Resolves only once the blob is actually written. Callers await this before saving the entity, so a failed
        // upload must reject: resolving early would persist a file name pointing at a blob that does not exist.
        async uploadFilesAsync(entity, key) {
            key = key ? key + "File" : "file";
            const file = entity[key];

            if (!(file instanceof File)) return;

            const store = this.$store;
            const fileName = entity[key + "Name"];

            try {
                // Step 1: Request a pre-signed URL from the back-end
                const results = await this.web(`/auth/azure-storage-credentials?fileName=${fileName}`, "Requesting Azure credentials");

                if (!results || !results.preSignedUrl) {
                    throw new Error("Failed to retrieve pre-signed URL.");
                }

                store.commit("setRequestBusy", true);
                store.commit("setOverlayText", "Starting file upload: " + file.name);

                // Step 2: Upload the file to Azure using the pre-signed URL and track progress
                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', results.preSignedUrl, true);
                    xhr.setRequestHeader("x-ms-blob-type", "BlockBlob");
                    xhr.setRequestHeader('Content-Type', file.type);

                    // Track upload progress
                    xhr.upload.onprogress = (event) => {
                        if (event.lengthComputable) {
                            const percentage = Math.round((event.loaded / event.total) * 100);
                            store.commit("setOverlayText", `Uploading file ${file.name} -> ${event.loaded}/${event.total} ${percentage}%`);
                        }
                    };

                    // A rejected SAS comes back as a 403 response, which fires onload, not onerror.
                    xhr.onload = () => {
                        if (xhr.status >= 200 && xhr.status <= 299) {
                            resolve();
                        } else {
                            const e = new Error(`Upload of ${file.name} failed with status ${xhr.status}`);
                            e.status = xhr.status;
                            reject(e);
                        }
                    };

                    xhr.onerror = () => reject(new Error(`Upload of ${file.name} failed: network or CORS error`));
                    xhr.onabort = () => reject(new Error(`Upload of ${file.name} was aborted`));

                    xhr.send(file);
                });

                delete entity[key];
                console.log("File uploaded successfully.");
            } catch (err) {
                console.error(err);
                store.commit("setErrorCode", err.status || 0);
                throw err;
            } finally {
                store.commit("setRequestBusy", false);
                store.commit("setOverlayText", null);
            }
        }
    }
}